import React, { forwardRef } from 'react';

import { Icon, Image, Tooltip } from '@chakra-ui/react';
import {
  ChatCircleDots,
  EnvelopeSimple,
  Notification,
  Phone,
} from '@phosphor-icons/react';
import PropTypes from 'prop-types';

import microsoftTeamsLogo from '../../../assets/images/integrations/microsoft_teams/logo.svg';
import slackLogo from '../../../assets/images/integrations/slack/logo-lg.svg';
import whatsappLogo from '../../../assets/images/integrations/whatsapp/logo.svg';

const brandIcon = (key, src, alt) => (
  <Image
    key={key}
    src={src}
    alt={alt}
    boxSize="4"
    objectFit="contain"
  />
);

const icons = {
  email: ['Email', <Icon as={EnvelopeSimple} boxSize="4" key="email" />],
  slack: ['Slack', brandIcon('slack', slackLogo, 'Slack')],
  sms: ['SMS', <Icon as={ChatCircleDots} boxSize="4" key="sms" />],
  voice: ['Voice', <Icon as={Phone} boxSize="4" key="voice" />],
  apns: ['Push', <Icon as={Notification} boxSize="4" key="apns" />],
  fcm: [
    'Push',
    <Icon as={Notification} boxSize="4" color="content.secondary" key="fcm" />,
  ],
  whats_app: [
    'WhatsApp',
    brandIcon('whats_app', whatsappLogo, 'WhatsApp'),
  ],
  microsoft_teams: [
    'Microsoft Teams',
    brandIcon('microsoft_teams', microsoftTeamsLogo, 'Microsoft Teams'),
  ],
};

export const NotificationIcon = ({ type }) => {
  const [tooltipText, icon] = icons[type];

  if (!icon) return null;

  const SpecificIcon = forwardRef(({ children, ...rest }, ref) => (
    <span ref={ref} {...rest}>
      {children}
    </span>
  ));

  SpecificIcon.displayName = 'SpecificIcon';

  return (
    <Tooltip placement="top" hasArrow label={tooltipText}>
      <SpecificIcon>{icon}</SpecificIcon>
    </Tooltip>
  );
};

NotificationIcon.propTypes = {
  type: PropTypes.string.isRequired,
};
